import { useQuery, keepPreviousData } from '@tanstack/react-query'
import { searchParties, recentParties } from '../services/partiesSearchApi'
import type { PartySearchResult } from '../services/partiesSearchApi'

/** Search parties with autocomplete (fires when query >= 2 chars) */
export function usePartySearch(query: string, actorId?: string) {
  return useQuery<PartySearchResult[]>({
    queryKey: ['parties', 'search', query, actorId],
    queryFn: () => searchParties(actorId!, query),
    enabled: query.length >= 2 && !!actorId,
    staleTime: 30_000,
    placeholderData: keepPreviousData,
  })
}

/** Fetch most recently used parties */
export function useRecentParties(actorId?: string, limit = 5) {
  return useQuery<PartySearchResult[]>({
    queryKey: ['parties', 'recent', actorId],
    queryFn: () => recentParties(actorId!, limit),
    enabled: !!actorId,
    staleTime: 60_000,
  })
}

export type { PartySearchResult }
